export const BRAND_NAME = 'GAPPAQ';

/** Görsel kullanım için her zaman {@link BrandWordmark} bileşenini tercih edin. */
export const BRAND_TAGLINE = 'Kaliteli Hazır Giyim';

export const BRAND_SITE_TITLE = `${BRAND_NAME} — ${BRAND_TAGLINE}`;

export const isBrandName = (value) => {
  if (!value || typeof value !== 'string') return false;
  return value.replace(/\s/g, '').toLowerCase() === 'gappaq';
};
